import { watch } from 'vue';

import { useAnalytics } from '@satellite/composables/useAnalytics';
import { useWarehouseInfo } from './useWarehouseInfo';

export function useJunoAnalytics() {
  const analytics = useAnalytics();
  const { warehouseData } = useWarehouseInfo();

  watch(
    warehouseData,
    warehouse => {
      if (!warehouse) {
        return;
      }
      analytics.registerSuper({
        warehouse_id: warehouse.id ?? null,
        warehouse_name: warehouse.name ?? null,
        org_id: warehouse.org?.id ?? null,
        org_name: warehouse.org?.name ?? null
      });
    },
    { immediate: true }
  );
}
